const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export interface TwitterAuthResponse {
  authUrl: string;
}

export interface AuthCallbackResponse {
  success: boolean;
  user: {
    id: string;
    username: string;
    name: string;
    profileImageUrl?: string;
  };
  token: string;
}

export const authService = {
  async getTwitterAuthUrl(): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/api/auth/twitter`, {
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to get Twitter auth URL');
    }

    const data: TwitterAuthResponse = await response.json();
    return data.authUrl;
  },

  async handleCallback(code: string, state: string): Promise<AuthCallbackResponse> {
    const response = await fetch(
      `${API_BASE_URL}/api/auth/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
      {
        credentials: 'include',
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Authentication failed');
    }

    return await response.json();
  },
};
